<template>
    <div />
</template>

<script>

import { Fullscreen, Widget } from '@bryntum/schedulerpro';

export default {

    name : 'BryntumFullscreenButton',

    mounted() {
        this.button = Fullscreen.enabled ? Widget.create({
            type       : 'button',
            appendTo   : this.$el,
            icon       : 'b-icon b-icon-fullscreen',
            tooltip    : 'Fullscreen',
            onClick() {
                    if (Fullscreen.enabled) {
                        if (!Fullscreen.isFullscreen) {
                            Fullscreen.request(document.body);
                        }
                        else {
                            Fullscreen.exit();
                        }
                    }
                }
        }) : null;
    },

    beforeDestroy() {
        if (this.button) {
            Fullscreen.onFullscreenChange(null);
            this.button.destroy();
        }
    }

};
</script>
